module.exports = __webpack_public_path__ + "img/short-video.254bc082.webp";